import * as api from '../resources/manage-inventory.api';
import actionTypes from './action-types';

export const downloadManageInventoryDetailedReportByTabRequest = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_REQUEST,
  tabId,
});

export const downloadManageInventoryDetailedReportByTabSuccess = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_SUCCESS,
  tabId,
});

export const downloadManageInventoryDetailedReportByTabFailure = (tabId) => ({
  type: actionTypes.DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE_FAILURE,
  tabId,
});

export const downloadManageInventoryDetailedReportByTab = (config) => (dispatch, getState) => {
  try {
    const { session } = getState();
    const retailerIdFromStore = config.filters ? config.filters.retailerId : null;
    const retailerId = retailerIdFromStore || config.retailerId || session.retailer.retailerId;

    const requestParams = {
      ...config,
      retailerId,
    };

    dispatch(downloadManageInventoryDetailedReportByTabRequest(config.tabId));

    dispatch(downloadManageInventoryDetailedReportByTabSuccess(config.tabId));
    return api.downloadManageInventoryDetailedReportByTab(requestParams);
  } catch (error) {
    console.error('DOWNLOAD_MANAGE_INVENTORY_DETAILED_REPORT_BY_TYPE', error);
    dispatch(downloadManageInventoryDetailedReportByTabFailure(config.tabId));
  }
};



// WEBPACK FOOTER //
// ./src/modules/manage-inventory/actions/download-detailed-report-by-tab.actions.js